import { AdditionalFeature } from '@aloft/toolkit-shared';

import { AdditionalFeatureLabels } from './types.js';

export function extractAdditionalFeatures(
  sale: Element,
  featureLabels: AdditionalFeatureLabels,
): {
  additionalFeature1?: AdditionalFeature;
  additionalFeature2?: AdditionalFeature;
  additionalFeature3?: AdditionalFeature;
} {
  try {
    const otherTags = Array.from(sale.getElementsByTagName('OTHER_FEATURE_ADJUSTMENT'));

    // These values start at 1, not 0 in the XML - additionally these features come from a different place in
    // the subject property
    const val1 =
      otherTags
        .find((tag) => Number(tag.getAttribute('PropertyFeatureSequenceIdentifier')) === 1)
        ?.getAttribute('PropertyFeatureDescription') ?? undefined;

    const val2 =
      otherTags
        .find((tag) => Number(tag.getAttribute('PropertyFeatureSequenceIdentifier')) === 2)
        ?.getAttribute('PropertyFeatureDescription') ?? undefined;

    const val3 =
      otherTags
        .find((tag) => Number(tag.getAttribute('PropertyFeatureSequenceIdentifier')) === 3)
        ?.getAttribute('PropertyFeatureDescription') ?? undefined;

    return {
      additionalFeature1: val1
        ? {
            label: featureLabels.featureLabel1,
            value: val1,
          }
        : undefined,
      additionalFeature2: val2
        ? {
            label: featureLabels.featureLabel2,
            value: val2,
          }
        : undefined,
      additionalFeature3: val3
        ? {
            label: featureLabels.featureLabel3,
            value: val3,
          }
        : undefined,
    };
  } catch (e: unknown) {
    console.warn('Failed to parse additional features', e);
    return {};
  }
}
